<template>
  <div class="marinController">
    <div
      @click="shows = !shows"
      class="title"
      :class="shows ? 'titleOpen' : ''"
    >
      <div class="titles">{{ title }}</div>
      <i v-if="!shows" class="ico el-icon-arrow-down" />
      <i v-else class="ico el-icon-arrow-up" />
    </div>
    <el-collapse-transition>
      <div class="cont" v-if="shows">
        <slot></slot>
      </div>
    </el-collapse-transition>
  </div>
</template>
<script>
export default {
  data() {
    return {
      shows: true // 是否显示
    };
  },
  props: {
    show: {
      default: true
    },
    title: {
      default: null,
      type: String
    }
  },
  mounted() {
    this.shows = this.show;
  }
};
</script>
<style lang="less" scoped>
.marinController {
  .title {
    transition: all 0.2s;
    cursor: pointer;
    border-radius: 10px;
    background-color: #fff;
    display: flex;
    align-items: center;
    padding: 5px 20px;
    color: #0082a4;
    font-weight: bold;
    .titles {
      flex: 1;
    }
    .ico {
      font-size: 32px;
    }
  }
  .titleOpen {
    border-radius: 0px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    color: #fff;
    background-color: #0082a4;
  }
  // 内容页
  .cont {
    transition: all 0.2s;
    padding: 20px;
    background-color: #fff;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    transition: all 0.2s;
  }
  .contHidden {
    overflow: hidden;
    padding: 0 20px;
    height: 0px;
  }
}
</style>
